import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

import { customColors } from '../../theme/customColors';

export const linkBaseStyle = defineStyle({
  width: 'fit-content',
  color: customColors.text.link,
  // Inside an Alert, match the alert's semantic text color so the link reads
  // as part of the alert rather than a foreign blue — same pattern as
  // Alert's description, icon, and closeButton styles.
  '[data-status="info"] &': { color: customColors.text.info },
  '[data-status="error"] &': { color: customColors.text.error },
  '[data-status="success"] &': { color: customColors.text.success },
  '[data-status="warning"] &': { color: customColors.text.warning },
  '[data-status="neutral"] &': { color: customColors.text.primary },
  '[data-status="beta"] &': { color: customColors.text.beta },
  fontWeight: 'semibold',
  textDecoration: 'none',
  '& > .orbit-external-link-icon': {
    ml: 1,
    verticalAlign: 'baseline',
    transform: 'translateY(3px)',
    // Thicken the stroke slightly so the outlink glyph reads at a similar
    // weight to the accompanying semibold link text (default stroke is 1).
    strokeWidth: 1.5,
  },
  _hover: {
    textDecoration: 'underline',
    _disabled: {
      color: customColors.text.disabled,
    },
  },
  _active: {
    boxShadow: 'none',
  },
  _disabled: {
    color: customColors.text.disabled,
  },
  _focus: {
    boxShadow: 'unset',
  },
  _focusVisible: {
    outlineColor: customColors.border.focused,
    rounded: 'base',
    boxShadow: 'unset',
  },
});

export const LinkStyles = defineStyleConfig({
  baseStyle: linkBaseStyle,
});
